import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T100ClickShop() {

    /*
  useEffect(() => {
    UserService.sendEvent('ClickShop100');
  }, []);
*/

    const text = 'Buy a Card Box to get new cards.';

    return (
        <div>
            <div className={'T100Left'}></div>
            <div className={'T100Top'}></div>

            <TutorialGirl position={'Right'} undressingProcess={3} />
            <div className='tutorialContainer tutorialTopContainer100'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T100ClickShop;
